import { useEffect } from 'react';
import { Provider } from 'react-redux';

import App from '@/App';
import { store } from '@/store';
import { ConfirmDialogProvider } from '@/components/confirm-dialog-provider';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { BootstrapPhase, runBootstrap } from '@/features/app-state';

function AppWithSessionRestore() {
  const dispatch = useAppDispatch();
  const bootstrapPhase = useAppSelector((state) => state.appState.bootstrapPhase);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (bootstrapPhase === BootstrapPhase.Idle) {
      void dispatch(runBootstrap());
    }
  }, [bootstrapPhase, dispatch]);

  useEffect(() => {
    // Re-run bootstrap after login from /login flow.
    if (bootstrapPhase === BootstrapPhase.Unauthenticated && isAuthenticated) {
      void dispatch(runBootstrap());
    }
  }, [bootstrapPhase, isAuthenticated, dispatch]);

  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <ConfirmDialogProvider>
        <Toaster />
        <App />
      </ConfirmDialogProvider>
    </ThemeProvider>
  );
}

function AppContainer() {
  return (
    <Provider store={store}>
      <AppWithSessionRestore />
    </Provider>
  );
}

export default AppContainer;
